const Vue = require('vue')

Vue.component('form-fake-text', {
    props: {
        label: {
            type: String
        },
        hint: {
            type: String
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        model: {
            default: null
        },
        name: {
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        },
        holderClass () {
            return this.iconClass ? 'input-icon' : null
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        }
    },
    data () {
        return {
            fieldName: ''
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }
    },
    template: `
            <div class="form-group">
                <form-label v-if="hasLabel()" :hint="getHint()">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                <div v-bind:class="holderClass()">
                    <i v-bind:class="iconClass" v-if="iconClass"></i>
                    <div type="text" class="fake-form-control" v-bind:placeholder="placeholder" v-bind:data-field="fieldName" v-bind:disabled="disabled" :vtitle="model" v-tooltip>{{ model }}</div>
                </div>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/fake-text.js